import {Box, Modal, Text} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import Image from 'next/image';
import {MdHandshake, MdOutlinePlayCircleFilled} from 'react-icons/md';
import {
  WEB_SEMINARS_IMAGE_1,
  WEB_SEMINARS_IMAGE_2,
} from '../../../config/constants/img';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

export const WebSeminarsHeader: React.FC = () => {
  const {isPC} = useMediaQuery();
  const [opened, {open, close}] = useDisclosure(false);

  return (
    <>
      <Box className="w-full flex flex-col max-w-[100%] mb-[10px] pc:max-w-[70%] pc:flex-row">
        <Box className="relative pc:w-[850px] h-[160px] max-w-[100%]">
          <Box className="bg-[url('/next-image/web_seminars/title_back.gif')] absolute top-0 left-0 w-full h-full bg-cover bg-center" />
          <Box className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-70" />
          <Box className="absolute top-0 left-0 right-0 bottom-0 flex flex-col justify-center items-center z-10 p-32">
            <Text className="text-white text-md pc:text-xl">
              混んでなくて、いつでも聴ける
            </Text>
            <Text className="text-white text-[45px] pc:text-[60px]">
              Web合説
            </Text>
          </Box>
        </Box>
        <Box className="bg-white pc:h-[160px] pc:w-[360px] mx-w-[100%] px-32 py-8">
          <Box className="flex justify-between">
            <Box className="flex flex-col items-center ml-64 pc:ml-24">
              <MdOutlinePlayCircleFilled
                size={isPC ? 90 : 60}
                color="currentColor"
              />
              <Text className="text-sm">動画を観る</Text>
            </Box>
            <Box className="flex flex-col items-center mr-64 pc:mr-24">
              <MdHandshake size={isPC ? 90 : 60} color="currentColor" />
              <Text className="text-sm">企業とつながる</Text>
            </Box>
          </Box>

          <Box className="mt-8">
            <Text
              onClick={open}
              className="text-line-1 text-sm font-light cursor-pointer text-center"
            >
              <span className="border-b border-line-1">
                &gt; 使い方を詳しく見る
              </span>
            </Text>
          </Box>
        </Box>
      </Box>

      <Modal opened={opened} onClose={close}>
        <Box className="mb-[30px] pc:px-16">
          <Box className="flex justify-center items-center mb-[10px]">
            <MdOutlinePlayCircleFilled
              size={28}
              color="currentColor"
              className="mr-4"
            />
            <Text className="text-xl font-bold">動画を観る</Text>
          </Box>
          <Box className="flex">
            <Image
              src={WEB_SEMINARS_IMAGE_1}
              alt="説明を聞く"
              width={95}
              height={95}
              className="mr-[10px]"
            />
            <Text className="flex items-center text-[15px]">
              興味のある企業の「説明を聞く」ボタンをクリック！企業説明動画が再生されます。
            </Text>
          </Box>
        </Box>
        <Box className="pc:px-16">
          <Box className="flex justify-center items-center mb-[10px]">
            <MdHandshake size={28} color="currentColor" className="mr-4" />
            <Text className="text-xl font-bold">企業とつながる</Text>
          </Box>
          <Box className="flex">
            <Image
              src={WEB_SEMINARS_IMAGE_2}
              alt="スカウト"
              width={95}
              height={95}
              className="mr-[10px]"
            />
            <Text className="flex items-center text-[15px]">
              動画の視聴履歴は企業に伝わります。スカウトやメールが届くかもしれません。
            </Text>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
